<template>
  <page
    :sidebar="sidebar"
    :search="search"
    :searchItems="searchItems"
    :toolbar="toolbar"
    v-on:add="add"
    v-on:save="save"
    v-on:clear="clear"
    v-on:remove="remove"
    v-on:transfer="transfer"
  >
    <template v-slot:sidebar>
      <div class="d-flex justify-center">
        <v-radio-group v-model="allClients" row dense hide-details>
          <v-radio label="All" :value="true"></v-radio>
          <v-radio label="Location" :value="false"></v-radio>
        </v-radio-group>
      </div>
      <v-alert
        v-if="clients.items.length == 0"
        text
        outlined
        color="orange"
        icon="mdi-alert"
        >No Clients</v-alert
      >

      <v-alert
        v-else-if="searchedClients.length == 0"
        text
        outlined
        color="orange"
        icon="mdi-alert"
        >No matching clients</v-alert
      >

      <v-list v-else shaped>
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item
            v-for="(item, i) in searchedClients"
            :key="i"
            @click="view(item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
              <!-- <v-list-item-subtitle v-text="item.city"></v-list-item-subtitle>
              <v-list-item-subtitle v-text="item.postcode"></v-list-item-subtitle>-->
            </v-list-item-content>
            <v-list-item-action>
              <v-tooltip left :color="item.complete ? 'green' : 'red'">
                <template v-slot:activator="{ on }">
                  <font-awesome-icon
                    v-on="on"
                    :icon="item.complete ? 'check-circle' : 'circle'"
                    class="my-1"
                    :style="{ color: item.complete ? 'green' : 'red' }"
                  />
                </template>
                <span>{{ item.complete ? "Complete" : "Incomplete" }}</span>
              </v-tooltip>

              <v-tooltip
                v-for="(alert, index) in alert(item).slice(0, 1)"
                :key="index"
                right
                :color="
                  alert.empty ? 'green' : alert.expired ? 'red' : 'orange'
                "
              >
                <template v-slot:activator="{ on }">
                  <font-awesome-icon
                    v-on="on"
                    :key="index"
                    icon="exclamation-circle"
                    class="my-1"
                    :style="{
                      color: alert.empty
                        ? 'green'
                        : alert.expired
                        ? 'red'
                        : 'orange',
                    }"
                  />
                </template>
                <span>
                  {{
                    alert.empty
                      ? "No Alerts"
                      : alert.expired
                      ? `Expired: ${alert.type} - ${alert.date}`
                      : `Date Warning: ${alert.type} - ${alert.date}`
                  }}
                </span>
              </v-tooltip>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </template>

    <template v-slot:content>
      <div>
        <v-divider></v-divider>
        <v-tabs
          show-arrows
          v-model="tab"
          background-color="grey lighten-5"
          color="primary"
          center-active
        >
          <v-tab
            v-for="(tab, index) in tabItems"
            :key="index"
            :disabled="
              !isNew ? false : index == 0 ? false : item.template == null
            "
            >{{ tab }}</v-tab
          >
        </v-tabs>
        <v-divider></v-divider>
        <div v-if="errorMessage.length > 0">
          <v-alert
            v-for="(error, index) in errorMessage"
            :key="index"
            class="ma-0"
            dense
            text
            outlined
            color="red"
            icon="mdi-alert"
            >{{ error }}</v-alert
          >
        </div>

        <v-tabs-items v-model="tab" v-if="isNew">
          <v-tab-item>
            <client-info :client="item"></client-info>
          </v-tab-item>
          <v-tab-item>
            <client-rates :client="item"></client-rates>
          </v-tab-item>
          <v-tab-item>
            <attributes :obj="item" :template="false"></attributes>
          </v-tab-item>
          <v-tab-item>
            <documents :obj="item" :template="false"></documents>
          </v-tab-item>
        </v-tabs-items>

        <v-tabs-items v-model="tab" v-else>
          <v-tab-item>
            <client-summary :client="item"></client-summary>
          </v-tab-item>
          <v-tab-item>
            <client-info :client="item"></client-info>
          </v-tab-item>
          <v-tab-item>
            <client-rates :client="item"></client-rates>
          </v-tab-item>
          <v-tab-item>
            <attributes
              :obj="item"
              :template="false"
              :type="'Client'"
            ></attributes>
          </v-tab-item>
          <v-tab-item>
            <client-work-history :client="item"></client-work-history>
          </v-tab-item>
          <v-tab-item>
            <client-communication :client="item"></client-communication>
          </v-tab-item>
          <v-tab-item>
            <documents :obj="item" :template="false"></documents>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </template>
  </page>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment, { min } from "moment";

import clientSummary from "./client_summary";
import clientInfo from "./client_info";
import clientWorkHistory from "./client_work_history";
import clientCommunication from "./client_communication";
import clientRates from "./client_rates";
import attributes from "@/components/attributes";
import documents from "@/components/documents";

export default {
  components: {
    clientSummary,
    clientInfo,
    clientWorkHistory,
    clientCommunication,
    clientRates,
    attributes,
    documents,
  },
  props: {
    id: String,
  },
  data() {
    return {
      sidebar: {
        width: 250,
        visible: true,
        title: "Clients",
        pinned: false,
        isHovering: false,
      },
      searchItems: ["Name", "Address", "City", "Postcode"],
      search: {
        term: "",
        type: "Name",
        complete: 2,
        page: 1,
      },
      selectedItem: null,
      item: {},
      originalItem: {},
      tab: 0,
      errorMessage: [],
      allClients: false,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      clients: (state) => state.clients,
      templates: (state) => state.templates,
    }),
    loading() {
      return this.clients.loading;
    },
    isNew() {
      return !this.item._id;
    },
    searchedClients() {
      return this.clients.items.filter((client) => {
        return this.allClients
          ? true
          : client.location == this.account.location._id &&
              client.name
                .toLowerCase()
                .includes(this.search.term.toLowerCase());
      });
    },
    tabItems() {
      if (this.isNew) {
        return ["Info", "Rates", "Attributes", "Documents"];
      } else {
        return [
          "Summary",
          "Info",
          "Rates",
          "Attributes",
          "Work History",
          "Communication",
          "Documents",
        ];
      }
    },
    toolbar() {
      return {
        title: this.isNew ? "New Client" : this.item.name,
        add: !this.isNew,
        save: this.item !== this.originalItem && this.canEdit,
        clear: this.isNew,
        delete: !this.isNew,
        deleteItem: "client",
        transfer: !this.isNew,
      };
    },
    canEdit() {
      var val = "Clients";
      var user = this.account.user;
      if (user.role != "user" || this.account.location.name == "Demo") {
        return true;
      }
      var role = user.roles.find((r) => {
        return r.location == this.account.location._id;
      });
      if (!role) {
        return false;
      }
      var permission = role.permissions.find((p) => {
        return p.name == val;
      });
      if (!permission) {
        return false;
      }
      if (permission.permission != 2) {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchClient: "clients/fetchById",
      fetchClients: "clients/fetch",
      fetchTemplates: "templates/fetch",
      create: "clients/create",
      update: "clients/update",
      delete: "clients/delete",
      transferClient: "clients/transfer",
      fetchInvoiceChartData: "invoices/fetchInvoiceChartData",
    }),
    add() {
      this.item = {};
      this.originalItem = {};
      this.selectedItem = null;
      this.listIndex = null;
    },
    async save() {
      console.log(this.item);
      if (this.isValid()) {
        // this.isComplete();
        // this.checkReminders();

        var client = this.isNew
          ? await this.create(this.item)
          : await this.update(this.item);
        this.view(client);
      }
    },
    clear() {},
    async remove() {
      await this.delete(this.item);
      this.add();
    },

    async transfer(location) {
      await this.transferClient({ location, client: this.item._id });
      this.add();
    },

    async view(client) {
      var item = !this.id
        ? JSON.parse(JSON.stringify(client))
        : await this.fetchClient(this.id);
      item.rates.forEach((rate) => {
        var template = this.templates.items.find((template) => {
          return template._id == rate.template;
        });
        if (template) {
          rate.template = template;
        }
      });
      var template = this.templates.items.find((template) => {
        return template._id == item.template;
      });
      if (template) {
        item.template = template;
      }
      console.log(item, "huhu");
      this.item = { ...item };
      this.tab = 0;
      this.originalItem = { ...this.item };
    },

    checkTemplate(val) {
      if (val == null) {
        return;
      }
      console.log(val);
      if (val.attributes) {
        var attrs = val.attributes.map((attr) => {
          return {
            attribute: null,
            label: attr.label,
            type: attr.type,
            values: attr.values,
            _id: attr._id,
            required: attr.required,
            reminder: attr.reminder,
          };
        });
        var existingAttrs = this.item.attributes;
        console.log(existingAttrs);
        if (existingAttrs) {
          existingAttrs.forEach((attr) => {
            var index = attrs.findIndex((a) => {
              return attr._id == a._id;
            });
            if (index !== -1) {
              attrs.splice(index, 1, attr);
            } else {
              attrs.push(attr);
            }
          });
        }
        this.$set(this.item, "attributes", attrs);
      } else {
        this.$set(this.item, "attributes", []);
      }
      if (val.documents) {
        var docs = val.documents.map((doc) => {
          return {
            type: doc.type,
            filename: doc.filename,
            _id: doc._id,
            required: doc.required,
          };
        });
        var existingDocs = this.item.documents;
        if (existingDocs) {
          existingDocs.forEach((doc) => {
            var index = docs.findIndex((d) => {
              return doc._id == d._id;
            });
            if (index != -1) {
              docs.splice(index, 1, doc);
            } else {
              docs.push(doc);
            }
          });
        }
        this.$set(this.item, "documents", docs);
      } else {
        this.$set(this.item, "documents", []);
      }
    },
    isValid() {
      return true;
    },
    alert(client) {
      return [];
    },
  },
  watch: {
    async tab(val) {
      console.log(this.item);
      switch (val) {
        case 4:
          let start_date = moment().subtract(4, "weeks").format("YYYY-MM-DD");
          let end_date = moment().format("YYYY-MM-DD");
          await this.fetchInvoiceChartData({
            start_date: start_date,
            end_date: end_date,
            client_id: this.item._id,
            frequency: "daily",
          });
          break;
      }
    },
    isNew() {
      this.tab = 0;
    },
    item: {
      handler: function (val, oldVal) {
        // console.log(val);
        this.cleanObj(val);
      },
      deep: true,
    },
    "item.template": function (val) {
      console.log(val);
      this.checkTemplate(val);
    },
  },
  async mounted() {
    if (this.id) {
      this.view();
    }
    this.fetchClients();
    this.fetchTemplates();
    this.item = {};
  },
};
</script>

<style>
.active-panel {
  color: white !important;
  font-weight: 700;
  font-size: 1.2em !important;
}

.active-panel .v-expansion-panel-header__icon > i {
  color: white !important;
}
.v-expansion-panel-content__wrap {
  padding: 0px 10px !important;
}
</style>
